import { LoadingStatus } from '@/shared/lib/types/loading'
import { create } from 'zustand'

export interface StoreProps {
  loading: LoadingStatus
  setLoading: (loading: LoadingStatus) => void
}

const useStore = create<StoreProps>((set) => ({
  loading: 'init',
  setLoading: (loading) => set({ loading }),
}))

export default useStore
